<template>
  <div>
    <div v-if="pay.kktName!=null">
      <v-icon size="18" class="d-inline-block mr-2" style="margin-top:-2px">mdi-cash-register</v-icon>
      <div class="d-inline-block">{{pay.kktName}}</div>
      <tooltip-view v-if="!$tools.isEmpty(pay.kktSlip)">
        <template v-slot:action>
          <v-icon small class="px-1">mdi-receipt-text-outline</v-icon>
        </template>
        <template v-slot:content>
          <v-btn
              v-if="!$tools.isEmpty(pay.kktQrCode)"
              @click="$tools.openUrl('https://lk.platformaofd.ru/web/noauth/cheque?'+pay.kktQrCode, true)"
              depressed small
          >
            Ссылка на чек<v-icon small class="ml-2">mdi-open-in-new</v-icon>
          </v-btn>
          <div class="caption" v-html="$tools.nl2br(pay.kktSlip)"></div>
        </template>
      </tooltip-view>
    </div>
    <div v-if="pay.terminalName!=null">
      <v-icon size="18" class="d-inline-block mr-2" style="margin-top:-2px">mdi-credit-card-outline</v-icon>
      <div class="d-inline-block">{{pay.terminalName}}</div>
    </div>
  </div>
</template>

<script>
import TooltipView from "@/components/TooltipView.vue";

export default {
  components: {TooltipView},
  props:['pay'],
}
</script>